import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WantedLevelService } from '../../world/WantedLevelService';

@Component({
    selector: 'app-wanted-level',
    templateUrl: './wanted-level.component.html',
    styleUrls: ['./wanted-level.component.css']
})
export class WantedLevelComponent implements OnInit, OnDestroy {
    wantedLevel = 0;
    stars: boolean[] = [false, false, false, false, false];
    private destroy$ = new Subject<void>();

    constructor(private wantedLevelService: WantedLevelService) {}

    ngOnInit(): void {
        this.wantedLevelService.wantedLevel$
            .pipe(takeUntil(this.destroy$))
            .subscribe((level) => {
                this.wantedLevel = level;
                this.stars = Array.from({ length: 5 }, (_, i) => i < level);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
